import { render, staticRenderFns } from "./AddTutor.vue?vue&type=template&id=fe4bbffc&scoped=true"
import script from "./AddTutor.vue?vue&type=script&lang=js"
export * from "./AddTutor.vue?vue&type=script&lang=js"
import style0 from "./AddTutor.vue?vue&type=style&index=0&id=fe4bbffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4bbffc",
  null
  
)

export default component.exports